import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var CardContainer = styled.article(function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.colours.canvas.tertiary.main,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%'
  };
});
var BaseCardSection = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 3rem;\n  min-height: 3rem;\n  padding-block: ", ";\n  padding-inline: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.sizing.small;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.sizing.medium;
});
var CardHeader = styled(BaseCardSection).attrs({
  as: 'header'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n\n  /* React select dropdowns always have an id containing 'react-select-' */\n  &:has([id^='react-select-']) {\n    padding-left: ", ";\n  }\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main);
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizing.small;
});
var CardFooter = styled(BaseCardSection).attrs({
  as: 'footer'
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-top: ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.sizing.xxtiny, " solid ").concat(theme.colours.canvas.secondary.main);
});
var CardBody = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var ContentWrapper = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: ", ";\n  opacity: ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.sizing.medium;
}, function (_ref8) {
  var theme = _ref8.theme,
    $hasStatus = _ref8.$hasStatus;
  return $hasStatus ? theme.opacity.highlight : 1;
});
var CardGroupContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  gap: ", ";\n  flex-grow: 1;\n\n  ", " {\n    /* Each card takes full height minus 3rem + 0.5rem gap for the next cards header */\n    flex: 0 0 calc(100% - 3.5rem);\n  }\n\n  ", " {\n    flex-grow: 1;\n    overflow-y: hidden;\n  }\n\n  ", " {\n    height: 100%;\n    overflow-y: auto;\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.sizing.small;
}, CardContainer, CardBody, ContentWrapper);

export { CardBody, CardContainer, CardFooter, CardGroupContainer, CardHeader, ContentWrapper };
//# sourceMappingURL=Card.styles.js.map
